import styles from '@/components/models/travel/PricingBlock/PricingBlockServices/PricingBlockServices.module.scss'
import { Trans, useTranslation } from 'next-i18next'
import Col from 'react-bootstrap/Col'
import travelObject from '@/entities/travel/interface'
import * as React from 'react'

interface Props {
  includedServices: string
  excludedServices: string
  travel: travelObject
}

const PricingBlockServices = ({ includedServices, excludedServices, travel }: Props) => {
  const { t } = useTranslation('common')

  let furtherInformation = <></>
  if (travel.pricing.tourOperator?.name && !travel.pricing.tourOperator?.gtcPdf?.url) {
    furtherInformation = (
      <div className="mt-5">
        <div className={styles.title}>{t('travel.pricing.furtherInformation')}</div>
        <div>{t('travel.pricing.furtherInformationTextWithoutGtcLink', { tourOperator: travel.pricing.tourOperator.name })}</div>
      </div>
    )
  } else if (travel.pricing.tourOperator?.name) {
    furtherInformation = (
      <div className="mt-5">
        <div className={styles.title}>{t('travel.pricing.furtherInformation')}</div>
        <div>
          <Trans i18nKey="travel.pricing.furtherInformationTextWithGtcLink" values={{ tourOperator: travel.pricing.tourOperator.name }}>
            This tour is organized by our partner. The
            <a href={travel.pricing.tourOperator.gtcPdf.url} target={'_blank'} rel="noreferrer">
              gtc
            </a>
            of the tour operator apply.
          </Trans>
        </div>
      </div>
    )
  }

  return (
    <Col>
      <div className={styles.root}>
        <div className={styles.included}>
          <div className={styles.title}>{t('travel.pricing.includedServices')}</div>
          <div dangerouslySetInnerHTML={{ __html: includedServices }} />
        </div>
        <div className={styles.title}>{t('travel.pricing.excludedServices')}</div>
        <div dangerouslySetInnerHTML={{ __html: excludedServices }} />
        {furtherInformation}
      </div>
    </Col>
  )
}

export default PricingBlockServices
